import React from 'react'

const StudentAddons = () => {
  return (
    <div>StudentAddons</div>
  )
}

export default StudentAddons